import { Helmet } from "react-helmet";
import Header from '../header/Header';
import HeroCartelera from './cartelera/HeroCartelera';
import SliderCartelera from './cartelera/SliderCartelera';
import SliderTopTen from './cartelera/SliderTopTen';
import Filter from './cartelera/Filter';
import Footer from '../footer/Footer';

function Cartelera() {

  return (
    <>
        <Helmet>
            <link
            rel="stylesheet"
            type="text/css"
            charset="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
            />
            <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
            />
            <meta charSet="utf-8" />
            <title>Cartelera - XDigital Neo</title>
        </Helmet>
        <Header />
        <HeroCartelera />
        <SliderCartelera />
        <SliderTopTen />
        <Filter />
        <Footer />
    </>
  )
}

export default Cartelera